import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContractCreationComponent } from './contract-creation.component';
import { CoreModule } from 'app/core/core.module';
import { SiteListModule } from '@components/site-list/site-list.module';

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    SiteListModule
  ],
  declarations: [ContractCreationComponent],
  entryComponents: [ContractCreationComponent]
})
export class ContractCreationModule { }
